"use strict";

module.exports = function (accumulator, order, product, component) {
  if (component.size === '5x7' || component.size === '4x6') {
    return accumulator + '\nPUT IN TABLE NUMBER QUEUE';
  }

  return accumulator;
};